module.exports = __webpack_public_path__ + "img/smallCalen.f6358d83.svg";